module.exports = __webpack_public_path__ + "static/img/qrcode.d82a2bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qrcode.jpg
// module id = 114
// module chunks = 34